<template>
  <vue-element-loading class="loader" :active="loading" spinner="spinner" color="#FE4123" />
</template>

<script>
import VueElementLoading from "vue-element-loading";

export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  components: {
    VueElementLoading
  }
};
</script>

<style>
.shop.node-page .loader {
  background-color: #fff !important;
}
</style>
